/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'C' | 'E' | 'F';
}

const StatusVariations = {
  C: css`
    background: var(--purple);
  `,
  E: css`
    background: var(--orange);
  `,
  F: css`
    background: var(--green);
  `,
};

export const Container = styled.div`
  .titleWrapper {
    height: 230px;
    @media only screen and (max-width: 1100px) {
      height: 240px
    }
    @media only screen and (max-width: 1000px) {
      height: 250px
    }
    @media only screen and (max-width: 950px) {
      height: 300px
    }
    @media only screen and (max-width: 875px) {
      height: 200px
    }
    @media only screen and (max-width: 780px) {
      height: 250px
    }
    @media only screen and (max-width: 560px) {
      height: 300px
    }
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 25px;

    @media only screen and (max-width: 767px) {
      margin-left: 0px;
      justify-content: center;
    }
  }

  img {
    margin-left: 30px;
    margin-top: 10px;
    height: 80px;
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
  width: 50px;
  height: auto;
  cursor: pointer;
  :hover {
    color: var(--orange);
  }
  padding-right: 5px;
`;

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);

  align-items: center;
  justify-content: space-between;
  margin-left: 40px;
`;

export const ButtonsContainer = styled.h1`
  margin-left: 40px;
  .buttonsInitial {
    @media only screen and (max-width: 767px) {
      margin-left: 0px;
      justify-content: center;
    }
    display: flex;
    button {
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;
    }
    .pedido {
      margin-top: 16px;
      padding: 10px 40px;
      &:hover {
        background: #b14729;
      }
    }
  }
`;

export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  ${props => StatusVariations[props.status || 'C']}
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 28px;

  @media only screen and (max-width: 1225px) {
    flex-direction: column;
  }

  @media only screen and (max-width: 875px) {
    margin-top: 128px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 50px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 160px;
  }

  .filter {
    margin-right: 5px;
    @media only screen and (max-width: 1225px) {
      margin-bottom: 10px;
    }
    button {
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;

      &:hover {
        background: #9ea1a2;
      }
    }
  }

  .search {
    width: 100%;
    @media only screen and (max-width: 1225px) {
      margin-bottom: 10px;
    }
    form {
      position: relative;
    }
    div {
      height: 40px;
      margin-top: -4px;
      input {
        font-size: 18px;
      }
    }
    .searchButton {
      position: absolute;
      right: 0px;
      top: 0;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;

      &:hover: {
        background: red;
      }
    }
  }
  .buttonsContainer {
    display: flex;
    button {
      width: 120px;
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      transition: background 0.3s ease;
    }
    .clearFilters {
      width: 145px;
      border-radius: 5px;
      margin-left: 5px;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;
      background-color: var(--aside-background);

      &:hover {
        background: #9ea1a2;
      }

      @media only screen and (max-width: 1225px) {
        margin-left: 0px;
      }
    }
    .csv {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    .pdf {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
  }
`;

export const DetailLink = styled.div`
  cursor: pointer;
  color: var(--purple);
  text-decoration: underline;
  text-underline-position: under;
`;

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
`;
